import { Box, Icon, Text } from "@shopify/polaris";
import React from "react";
import { PageLayout } from "src/components/shopify/PageLayout";
import { PolarisCard } from "src/components/shopify/PolarisCard";

export default function (): React.ReactElement {
  const icon = require("@shopify/polaris-icons");

  return (
    <PageLayout
      pageProp={{
        title: "Playground",
        fullWidth: false,
      }}
    >
      <PolarisCard>
        <Box>
          <div style={{ display: "grid", gridTemplateColumns: "auto auto auto" }}>
            {Object.keys(icon).map((x) => {
              return (
                <div key={x} style={{ display: "flex", padding: "1rem", border: "1px solid rgba(0, 0, 0, 0.8)" }}>
                  <div style={{ width: 50 }}>
                    <Icon source={icon[x]} />
                  </div>
                  <Text as="p" variant="bodyMd">
                    {x}
                  </Text>
                </div>
              );
            })}
          </div>
        </Box>
      </PolarisCard>
    </PageLayout>
  );
}
